import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserTrackingStore = defineStore('userTracking', () => {
    const eventOptions = ref<{ label: string; value: string }[]>([
        {
            label: 'Visit Homepage',
            value: 'visit_homepage',
        },
        {
            label: 'Visit Campaign',
            value: 'visit_campaign',
        },
        {
            label: 'Visit Account Overview',
            value: 'visit_account_overview',
        },
        {
            label: 'Visit Orders',
            value: 'visit_orders',
        },
        {
            label: 'Visit Order',
            value: 'visit_order',
        },
        {
            label: 'Visit Wallet',
            value: 'visit_wallet',
        },
        {
            label: 'Start Investment Process',
            value: 'start_investment_process',
        },
        {
            label: 'Investment Progress',
            value: 'investment_progress',
        },
        {
            label: 'Order Created',
            value: 'order_created',
        },
        {
            label: 'Signature Process',
            value: 'signature_process',
        },
        {
            label: 'Read Full Campaign',
            value: 'read_full_campaign',
        },
        {
            label: 'Campaign Tab Change',
            value: 'campaign_tab_change',
        },
        {
            label: 'Open Document',
            value: 'open_document',
        },
        {
            label: 'Withdrawal Attempt',
            value: 'withdrawal_attempt',
        },
        {
            label: 'Deposit Attempt',
            value: 'deposit_attempt',
        },
    ])

    return {
        eventOptions,
    }
})
